import { useState } from 'react';
import { createStore } from 'reusable';

export const useNavTab = createStore(() => useState('details'));
export const useSavePending = createStore(() => useState(false));
export const useDeletePending = createStore(() => useState(false));
